import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-167ab7ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "table-page-search-submitButtons",
  style: { float: 'right', overflow: 'hidden' } || {}
}
const _hoisted_2 = { class: "button-collection-r" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["onClick"]

import { ref, onMounted, reactive } from "vue";
import { useRoute } from "vue-router";
import { fmoney } from "@/utils/tools";
import { getDic } from "@/api/pos";
import { getFlexEmployeeList, exportFlexEmployeeList } from "@/api/flex";
import {
  DownOutlined,
  UpOutlined,
  DownloadOutlined,
  BarsOutlined,
  ExportOutlined,
} from "@ant-design/icons-vue";
import FlexExportRecordModal from "./modules/FlexExportRecordModal.vue";
import FlexBoughtRecordModal from "./modules/FlexBoughtRecordModal.vue";
import { FormInstance, message } from "ant-design-vue";
import { debounce } from "@/utils/tools";
interface FormState {
  pageNum: string | null | number;
  pageSize: string | null | number;
  state: string | null;
  idNum: string | null;
  name: string | null;
  jobNumber: string | null;
  personnelLabel: string | null;
  choiceEndDateFrom: string | null;
  choiceEndDateTo: string | null;
  standardBudgetFrom: string | null;
  standardBudgetTo: string | null;
  budgetBalanceFrom: string | null;
  budgetBalanceTo: string | null;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FlexDataCheck',
  setup(__props) {

const dataSource = ref<Array<any>>([]);
const loading = ref<boolean>(false);
const route = useRoute();
const checkPosDetailInfo = ref(null);
const currentPage = ref(1);
const pageSizeConfig = ref(10);
const totalData = ref(0);
const flexExportRecordModal = ref(null);
const flexBoughtRecordModal = ref(null);
const personnelLabelList = ref<Array<any>>([]);
const employeeStateList = ref<Array<any>>([]);
const choiceEndDateFrom = ref<string>("");
const choiceEndDateTo = ref<string>("");
const openMore = ref<boolean>(false);
const formRef = ref<FormInstance>();
const formState = reactive<FormState>({
  pageNum: 1,
  pageSize: 10,
  state: null,
  idNum: null,
  name: null,
  jobNumber: null,
  personnelLabel: null,
  choiceEndDateFrom: null,
  choiceEndDateTo: null,
  standardBudgetFrom: null,
  standardBudgetTo: null,
  budgetBalanceFrom: null,
  budgetBalanceTo: null,
});
const columns = ref<Array<any>>([
  {
    title: "姓名",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "证件号",
    dataIndex: "idNum",
    key: "idNum",
  },
  {
    title: "工号",
    dataIndex: "jobNumber",
    key: "jobNumber",
  },
  {
    title: "人员标签",
    dataIndex: "personnelLabelZh",
    key: "personnelLabelZh",
  },
  {
    title: "生效日期",
    dataIndex: "effectiveDate",
    key: "effectiveDate",
  },
  {
    title: "标准积分",
    dataIndex: "standardBudget",
    key: "standardBudget",
  },
  {
    title: "实际积分",
    dataIndex: "actualBudget",
    key: "actualBudget",
  },
  {
    title: "剩余积分",
    dataIndex: "budgetBalance",
    key: "budgetBalance",
  },
  {
    title: "窗口期",
    dataIndex: "choiceDateRange",
    key: "choiceDateRange",
  },
  {
    title: "状态",
    dataIndex: "stateZh",
    key: "stateZh",
  },
  {
    title: "购买记录",
    dataIndex: "action",
    key: "action",
  },
]);

onMounted(() => {
  getTableData();
  getDic({}).then((res) => {
    personnelLabelList.value = res.data.personnelLabelList;
    employeeStateList.value = res.data.employeeStateList;
  }).catch;
});

const getTableData = async (data: any = {}) => {
  loading.value = true;
  let res: any = await getFlexEmployeeList(data);
  if (res.code == 200) {
    dataSource.value = res.data.dataList;
    totalData.value = res.data.total;
    currentPage.value = res.data.pageNum;
  }

  loading.value = false;
};

const showExportModal = () => {
  if (flexExportRecordModal.value) flexExportRecordModal.value.showModal();
};

const handleExport = debounce(async () => {
  let values = {
    state: formState.state,
    choiceEndDateFrom: choiceEndDateFrom.value,
    choiceEndDateTo: choiceEndDateTo.value,
    standardBudgetTo: formState.standardBudgetTo,
    standardBudgetFrom: formState.standardBudgetFrom,
    budgetBalanceFrom: formState.budgetBalanceFrom,
    budgetBalanceTo: formState.budgetBalanceTo,
  };
  let resExport: any = await exportFlexEmployeeList(values);
  if (resExport.code == 200) {
    message.success("导出成功，请前往导出记录查看下载");
  } else {
    message.error("导出失败");
  }
}, 500);

const handleFinishFailed = (errors: any) => {
  console.log(errors);
};

const showModalByCheckBoughtRecordModal = (record: any) => {
  if (flexBoughtRecordModal.value)
    flexBoughtRecordModal.value.showModal(record);
};

const handleSearch = (values: FormState) => {
  values.choiceEndDateFrom = choiceEndDateFrom.value;
  values.choiceEndDateTo = choiceEndDateTo.value;
  values.standardBudgetTo = formState.standardBudgetTo;
  values.standardBudgetFrom = formState.standardBudgetFrom;
  values.budgetBalanceFrom = formState.budgetBalanceFrom;
  values.budgetBalanceTo = formState.budgetBalanceTo;
  getTableData(values);
};

const onChangeRangePicker = (date: any, dateString: any) => {
  choiceEndDateFrom.value = dateString[0];
  choiceEndDateTo.value = dateString[1];
};
const onChangePage = (pageNum: number, pageSize: number) => {
  let data = formState as FormState;
  data.pageNum = pageNum;
  data.pageSize = pageSize;
  currentPage.value = pageNum;
  pageSizeConfig.value = pageSize;
  getTableData(data);
};
const Reset = () => {
  if (formRef.value) formRef.value.resetFields();
  choiceEndDateFrom.value = "";
  choiceEndDateTo.value = "";
  for (let key in formState) {
    formState[key] = null;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, { style: {"max-width":"1440px","margin":"0 auto","margin-top":"32px"} }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_a_form, {
            ref_key: "formRef",
            ref: formRef,
            model: formState,
            onFinish: handleSearch,
            onFinishFailed: handleFinishFailed,
            style: {"text-align":"left"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xxl: 6,
                    xl: 8,
                    lg: 8,
                    sm: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        label: "姓名：",
                        name: "name"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: formState.name,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.name) = $event)),
                            placeholder: "请输入姓名"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xxl: 6,
                    xl: 8,
                    lg: 8,
                    sm: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        label: "证件号：",
                        name: "idNum"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: formState.idNum,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.idNum) = $event)),
                            placeholder: "请输入证件号"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (openMore.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_a_col, {
                          xxl: 6,
                          xl: 6,
                          lg: 8,
                          sm: 24
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, {
                              label: "人员标签：",
                              name: "personnelLabel"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  value: formState.personnelLabel,
                                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formState.personnelLabel) = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(personnelLabelList.value, (foo) => {
                                      return (_openBlock(), _createBlock(_component_a_select_option, {
                                        key: foo.code
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(foo.name), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xxl: 6,
                          xl: 8,
                          lg: 8,
                          sm: 24
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, {
                              label: "工号：",
                              name: "jobNumber"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  value: formState.jobNumber,
                                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formState.jobNumber) = $event)),
                                  placeholder: "请输入工号"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xxl: 6,
                          xl: 8,
                          lg: 8,
                          sm: 24
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, {
                              label: "人员状态：",
                              name: "state"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  value: formState.state,
                                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((formState.state) = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employeeStateList.value, (foo) => {
                                      return (_openBlock(), _createBlock(_component_a_select_option, {
                                        key: foo.code
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(foo.name), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xxl: 6,
                          xl: 6,
                          lg: 8,
                          sm: 24
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, {
                              label: "窗口截止日期范围：",
                              name: "choiceEndDateFrom"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_range_picker, {
                                  value: formState.choiceEndDateFrom,
                                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((formState.choiceEndDateFrom) = $event)),
                                  placeholder: ['开始日期', '结束日期'],
                                  onChange: onChangeRangePicker
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xxl: 6,
                          xl: 6,
                          lg: 8,
                          sm: 24
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "标准积分范围" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input_number, {
                                  style: {"margin-right":"4px"},
                                  value: formState.standardBudgetFrom,
                                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((formState.standardBudgetFrom) = $event))
                                }, null, 8, ["value"]),
                                _createTextVNode("-- "),
                                _createVNode(_component_a_input_number, {
                                  value: formState.standardBudgetTo,
                                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((formState.standardBudgetTo) = $event))
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xxl: 6,
                          xl: 6,
                          lg: 8,
                          sm: 24
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, { label: "剩余积分范围" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input_number, {
                                  style: {"margin-right":"4px"},
                                  value: formState.budgetBalanceFrom,
                                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((formState.budgetBalanceFrom) = $event))
                                }, null, 8, ["value"]),
                                _createTextVNode("-- "),
                                _createVNode(_component_a_input_number, {
                                  value: formState.budgetBalanceTo,
                                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((formState.budgetBalanceTo) = $event))
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_col, {
                    xxl: 6,
                    xl: 6,
                    lg: 8,
                    sm: 24
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_1, [
                        _createVNode(_component_a_button, {
                          style: {"margin-left":"20px","width":"90px"},
                          type: "primary",
                          "html-type": "submit"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_button, {
                          style: {"margin-left":"16px","width":"90px"},
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (Reset()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("重置")
                          ]),
                          _: 1
                        }),
                        _createElementVNode("a", {
                          onClick: _cache[11] || (_cache[11] = 
                  () => {
                    openMore.value = !openMore.value;
                  }
                ),
                          style: {"margin-left":"8px","color":"#42b983"}
                        }, [
                          _createTextVNode(_toDisplayString(openMore.value ? "收起" : "展开") + " ", 1),
                          (!openMore.value)
                            ? (_openBlock(), _createBlock(_unref(DownOutlined), { key: 0 }))
                            : (_openBlock(), _createBlock(_unref(UpOutlined), { key: 1 }))
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _unref(handleExport)
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ExportOutlined)),
              _createTextVNode("导出 ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            class: "button-c",
            type: "default",
            onClick: showExportModal
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BarsOutlined)),
              _createTextVNode("导出记录")
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_a_table, {
          style: {"margin-top":"16px"},
          dataSource: dataSource.value,
          columns: columns.value,
          pagination: {
        current: currentPage.value,
        onChange: onChangePage,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        total: totalData.value,
        pageSize: pageSizeConfig.value,
        showTotal: (totalData) => `共 ${totalData} 条数据`,
      },
          loading: loading.value
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'payoutAmount')
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(fmoney)(record.payoutAmount)), 1))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (showModalByCheckBoughtRecordModal(record)),
                    style: {"color":"#42b983"}
                  }, "查看", 8, _hoisted_5)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "loading"])
      ]),
      _: 1
    }),
    _createVNode(FlexBoughtRecordModal, {
      ref_key: "flexBoughtRecordModal",
      ref: flexBoughtRecordModal
    }, null, 512),
    _createVNode(FlexExportRecordModal, {
      ref_key: "flexExportRecordModal",
      ref: flexExportRecordModal
    }, null, 512)
  ], 64))
}
}

})